import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye, faCopy } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import moneda from '../../moneda';
import { Link as Anchor } from "react-router-dom";
export default function ProductosData() {
    const WEEKDAYS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
    const [demora, setDemora] = useState({}); // minutos
    const [dias, setDias] = useState({});
    const [profesionales, setProfesionales] = useState([]);

    /**
     * Función auxiliar para calcular el array de turnos como objetos.
     * Retorna: [{ hora: "08:00", activo: true }, ...]
     */
    const calcularArrayTurnos = (inicio, fin, tiempoDemora) => {
      if (!inicio || !fin || !tiempoDemora) return [];
      const turnos = [];
      let [hi, mi] = inicio.split(":").map(Number);
      let [hf, mf] = fin.split(":").map(Number);

      let actual = hi * 60 + mi;
      const finMin = hf * 60 + mf;
      const d = Number(tiempoDemora);

      while (actual + d <= finMin) {
        const h = String(Math.floor(actual / 60)).padStart(2, "0");
        const m = String(actual % 60).padStart(2, "0");
        // Se guardan como objetos para poder "apagarlos" individualmente
        turnos.push({ hora: `${h}:${m}`, activo: true });
        actual += d;
      }
      return turnos;
    };

    const toggleDia = (profId, dia) => {
      setDias((prev) => {
        const profConfig = prev[profId] || {};
        if (profConfig[dia]) {
          const newProfConfig = { ...profConfig };
          delete newProfConfig[dia];
          return { ...prev, [profId]: newProfConfig };
        } else {
          const inicioDef = "08:00";
          const finDef = "17:00";
          const tiempo = demora[profId] || 30;
          return {
            ...prev,
            [profId]: {
              ...profConfig,
              [dia]: {
                inicio: inicioDef,
                fin: finDef,
                turnos: calcularArrayTurnos(inicioDef, finDef, tiempo),
              },
            },
          };
        }
      });
    };

    const cambiarHora = (profId, dia, campo, valor) => {
      setDias((prev) => {
        const configActual = prev[profId][dia];
        const nuevaConfigDia = { ...configActual, [campo]: valor };

        // Recalcular turnos automáticamente al cambiar hora de inicio o fin
        nuevaConfigDia.turnos = calcularArrayTurnos(
          campo === "inicio" ? valor : nuevaConfigDia.inicio,
          campo === "fin" ? valor : nuevaConfigDia.fin,
          demora[profId] || 30
        );

        return {
          ...prev,
          [profId]: { ...prev[profId], [dia]: nuevaConfigDia },
        };
      });
    };

    // Nueva función para habilitar/deshabilitar un turno específico (ej: almuerzo)
    const toggleTurnoEspecifico = (profId, dia, horaPresionada) => {
      setDias((prev) => {
        const turnosActualizados = prev[profId][dia].turnos.map((t) =>
          t.hora === horaPresionada ? { ...t, activo: !t.activo } : t
        );

        return {
          ...prev,
          [profId]: {
            ...prev[profId],
            [dia]: { ...prev[profId][dia], turnos: turnosActualizados },
          },
        };
      });
    };

    // Función para cuando cambias la duración (demora) de un profesional
    const cambiarDemoraProfesional = (profId, nuevoValor) => {
      const tiempo = Number(nuevoValor);
      setDemora((prev) => ({ ...prev, [profId]: tiempo }));

      setDias((prev) => {
        const profConfig = prev[profId];
        if (!profConfig) return prev;

        const nuevaConfigConNuevosTurnos = {};
        Object.keys(profConfig).forEach((dia) => {
          nuevaConfigConNuevosTurnos[dia] = {
            ...profConfig[dia],
            turnos: calcularArrayTurnos(profConfig[dia].inicio, profConfig[dia].fin, tiempo),
          };
        });

        return { ...prev, [profId]: nuevaConfigConNuevosTurnos };
      });
    };

    const [rules, setRules] = useState([]);
    const [newRuleType, setNewRuleType] = useState("weekday");
    const [newRuleValue, setNewRuleValue] = useState("");


    const [configuracion, setConfiguracion] = useState([]);
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioTa, setNuevoPrecioTa] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroCategoria2, setFiltroCategoria2] = useState('');
    const [filtroMasVendido, setFiltroMasVendido] = useState('');
    const [productoDisponible, setProductoDisponible] = useState('Si');

    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);

    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [nuevaImagen2, setNuevaImagen2] = useState(null);
    const [nuevaImagen3, setNuevaImagen3] = useState(null);
    const [nuevaImagen4, setNuevaImagen4] = useState(null);

    const [selectedSection, setSelectedSection] = useState('texto');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [categorias, setCategoras] = useState([]);
    const [categoriaEsServicio, setCategoriaEsServicio] = useState(false);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [precio1, setPrecio1] = useState('');
    const [precio2, setPrecio2] = useState('');
    const [precio3, setPrecio3] = useState('');
    const [precio4, setPrecio4] = useState('');
    const [precio5, setPrecio5] = useState('');
    const [precio6, setPrecio6] = useState('');
    const [precio7, setPrecio7] = useState('');
    const [precio8, setPrecio8] = useState('');
    const [precio9, setPrecio9] = useState('');
    const [precio10, setPrecio10] = useState('');
    const [nuevoStock, setNuevoStock] = useState('');
    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };
    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };


    useEffect(() => {
        cargarProductos();

    }, []);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoTitulo(producto.titulo);
        setNuevaDescripcion(producto.descripcion);
        setNuevoPrecio(producto.precio);
        setRules(producto.rules_prices ? JSON.parse(producto.rules_prices) : []);
        setNuevoMasVendido(producto.masVendido)
        setNuevaCategoria(producto.idCategoria)
        setItem1(producto.item1);
        setItem2(producto.item2);
        setItem3(producto.item3);
        setItem4(producto.item4);
        setItem5(producto.item5);
        setItem6(producto.item6);
        setItem7(producto.item7);
        setItem8(producto.item8);
        setItem9(producto.item9);
        setItem10(producto.item10);
        setPrecio1(producto.precio1);
        setPrecio2(producto.precio2);
        setPrecio3(producto.precio3);
        setPrecio4(producto.precio4);
        setPrecio5(producto.precio5);
        setPrecio6(producto.precio6);
        setPrecio7(producto.precio7);
        setPrecio8(producto.precio8);
        setPrecio9(producto.precio9);
        setPrecio10(producto.precio10);
        setNuevoPrecioAnterior(producto.precioAnterior)
        setNuevoStock(producto.stock)
    }, [producto]);

    const cargarConfiguracion = () => {
        fetch(`${baseURL}/configGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // console.log("Config",data.config);
                setConfiguracion(data.config || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarProductos = () => {
        cargarConfiguracion();
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/productDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const duplicarProducto = (idProducto) => {
        Swal.fire({
            title: '¿Duplicar producto?',
            text: 'Se creará una copia exacta de este producto',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, duplicar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('idProducto', idProducto);

                fetch(`${baseURL}/productoDuplicate.php`, {
                    method: 'POST',
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.mensaje) {
                            Swal.fire(
                                '¡Duplicado!',
                                data.mensaje,
                                'success'
                            );
                            cargarProductos();
                        } else if (data.error) {
                            Swal.fire(
                                'Error',
                                data.error,
                                'error'
                            );
                        }
                    })
                    .catch(error => {
                        console.error('Error al duplicar el producto:', error);
                        toast.error('Error al duplicar el producto');
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setProductoDisponible(item.disponible);
        setNuevoTitulo(item.titulo);
        setNuevaDescripcion(item.descripcion);
        setNuevoPrecio(item.precio);
        if(item.dias && item.dias != ""){
            setDias(JSON.parse(item.dias));
        }
        if(item.demora && item.demora != ""){
            setDemora(JSON.parse(item.demora));
        }
        setRules(item.rules_prices ? JSON.parse(item.rules_prices) : []);
        setNuevaCategoria(item.idCategoria);
        onCheckCategoriaEsServicio(item.idCategoria, item.dias);
        setModalVisible(true);
    };

    const onCheckCategoriaEsServicio = (idCategoria, itemDias = null) =>{
        let catSelected = categorias.filter(categoriaFiltrada => categoriaFiltrada.idCategoria == idCategoria);
        const tieneConfiguracionDias = itemDias && itemDias !== "" && itemDias !== "{}";
        
        const textoNormalizado = (str) => 
            str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        let esServicioPorNombre = false;
        if(catSelected[0]) {
            const nombreCat = textoNormalizado(catSelected[0].categoria.toLowerCase());
            esServicioPorNombre = nombreCat.includes("servicio") || 
                                  nombreCat.includes("depilacion") || 
                                  nombreCat.includes("estetica") || 
                                  nombreCat.includes("peluqueria") || 
                                  nombreCat.includes("reserva") || 
                                  nombreCat.includes("turno") || 
                                  nombreCat.includes("cita") || 
                                  nombreCat.includes("masaje") || 
                                  nombreCat.includes("spa") ||
                                  nombreCat.includes("unas") ||
                                  nombreCat.includes("cejas") ||
                                  nombreCat.includes("pestanas") ||
                                  nombreCat.includes("facial");
        }

        const tieneProfesionales = profesionales.some(prof => {
            try {
                const catsProf = typeof prof.categorias === 'string' 
                    ? JSON.parse(prof.categorias) 
                    : prof.categorias;
                return Array.isArray(catsProf) && catsProf.includes(idCategoria.toString());
            } catch {
                return false;
            }
        });

        let isAcomodationValue = esServicioPorNombre || tieneProfesionales || tieneConfiguracionDias;
        setCategoriaEsServicio(isAcomodationValue);
        if(!isAcomodationValue){
            setProductoDisponible('Si');
        }
    }

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.includes(filtroTitulo);
        const categoriaMatch = item.idCategoria.toString().includes(filtroCategoria);
        const masVendidoMatch = !filtroMasVendido || item.masVendido.includes(filtroMasVendido);
        const categoriasMatch = !filtroCategoria2 || item.categoria.includes(filtroCategoria2);
        return idMatch && tituloMatch && categoriaMatch && masVendidoMatch && categoriasMatch;
    });

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Titulo: item.titulo,
            Descripcion: item.descripcion,
            Precio: item.precio,
            Fecha: item.createdAt,
            MasVendido: item.masVendido,
            Imagen1: item.imagen1,
            Imagen2: item.imagen2,
            Imagen3: item.imagen3,
            Imagen4: item.imagen4,
            Imagen5: item.imagen5,
            Imagen6: item.imagen6,
            Imagen7: item.imagen7,
            Imagen8: item.imagen8,
            Imagen9: item.imagen9,
            Imagen10: item.imagen10,
            Imagen11: item.imagen11,
            Imagen12: item.imagen12,
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Productos', 10, 10);

        const columns = [
            { title: 'IdProducto', dataKey: 'idProducto' },
            { title: 'Titulo', dataKey: 'titulo' },
            { title: 'Descripcion', dataKey: 'descripcion' },
            { title: 'Precio', dataKey: 'precio' },
            { title: 'MasVendido', dataKey: 'masVendido' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Titulo: item.titulo,
            Descripcion: item.descripcion,
            Precio: item.precio,
            MasVendido: item.masVendido,
            Fecha: item.createdAt,

        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('productos.pdf');
    };

    const recargarProductos = () => {
        cargarProductos();
    };
    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const handleUpdateText = (idProducto) => {
        const payload = {

            nuevoTitulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            nuevaDescripcion: nuevaDescripcion !== undefined ? nuevaDescripcion : producto.descripcion,
            nuevoPrecio: nuevoPrecio !== '' ? nuevoPrecio : producto.precio,
            rules_prices: rules !== '' ? JSON.stringify(rules) : producto.rules_prices,
            nuevaCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            masVendido: nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido,
            demora: JSON.stringify(demora),
            dias: JSON.stringify(dias),
            disponible: productoDisponible,
            item1: item1 !== undefined ? item1 : producto.item1,
            item2: item2 !== undefined ? item2 : producto.item2,
            item3: item3 !== undefined ? item3 : producto.item3,
            item4: item4 !== undefined ? item4 : producto.item4,
            item5: item5 !== undefined ? item5 : producto.item5,
            item6: item6 !== undefined ? item6 : producto.item6,
            item7: item7 !== undefined ? item7 : producto.item7,
            item8: item8 !== undefined ? item8 : producto.item8,
            item9: item9 !== undefined ? item9 : producto.item9,
            item10: item10 !== undefined ? item10 : producto.item10,
            precio1: precio1 !== undefined ? precio1 : producto.precio1,
            precio2: precio2 !== undefined ? precio2 : producto.precio2,
            precio3: precio3 !== undefined ? precio3 : producto.precio3,
            precio4: precio4 !== undefined ? precio4 : producto.precio4,
            precio5: precio5 !== undefined ? precio5 : producto.precio5,
            precio6: precio6 !== undefined ? precio6 : producto.precio6,
            precio7: precio7 !== undefined ? precio7 : producto.precio7,
            precio8: precio8 !== undefined ? precio8 : producto.precio8,
            precio9: precio9 !== undefined ? precio9 : producto.precio9,
            precio10: precio10 !== undefined ? precio10 : producto.precio10,
            precioAnterior: nuevoPrecioAnterior !== 0 ? nuevoPrecioAnterior : producto.precioAnterior,
            stock: nuevoStock !== '' ? nuevoStock : producto.stock,
        };

        fetch(`${baseURL}/productoTextPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {

                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos();
                    cerrarModal()
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleFileChange = (event, setFile, setPreview) => {
        const file = event.target.files[0];

        if (file) {
            // Crear una URL de objeto para la imagen seleccionada
            const previewURL = URL.createObjectURL(file);
            setFile(file);
            setPreview(previewURL);
        }
    };
    const handleEditarImagenBanner = (idProducto) => {
        const formData = new FormData();
        formData.append('idProducto', idProducto);
        formData.append('updateAction', 'update'); // Campo adicional para indicar que es una actualización

        if (nuevaImagen) {
            formData.append('imagen1', nuevaImagen);
        }
        if (nuevaImagen2) {
            formData.append('imagen2', nuevaImagen2);
        }
        if (nuevaImagen3) {
            formData.append('imagen3', nuevaImagen3);
        }
        if (nuevaImagen4) {
            formData.append('imagen4', nuevaImagen4);
        }

        fetch(`${baseURL}/productoImagePut.php`, {
            method: 'POST',  // Cambiado a POST
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');

                }

                return response.json();
            })
            .then(data => {
                if (data.error) {

                    toast.error(data.error);
                    console.log(formData)
                } else {

                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                console.log(error)
                toast.error(error.message);
                console.log(formData)
                console.log(idProducto)
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        cargarCategoria();
        cargarProfesionales();
    }, []);

    const cargarProfesionales = () => {
        fetch(`${baseURL}/profesionalesGet.php`)
            .then(res => res.json())
            .then(data => setProfesionales(data.profesionales || []))
            .catch(err => console.error(err));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const addRule = () => {
        if (!newRuleValue.trim()) return;

        const newRule = {
            type: newRuleType,
            value: newRuleValue
        };

        setRules([...rules, newRule]);
        setNewRuleValue("");
    };

    const removeRule = (index) => {
        const updated = rules.filter((_, i) => i !== index);
        setRules(updated);
    };

    const filteredWeekdays = WEEKDAYS.filter(
        d => !rules.some(r => r.type === "weekday" && r.value === d)
    );


    return (
        <div>

            
            <div className='deFlexContent' style={{ display: 'flex' }}>

                <div className='deFlex2'>
                    <NewProduct 
                    productosCantidadMaxima={configuracion.cantidad_productos} 
                    productosCantidadAhora={productos.length} 
                    />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    {/* 
                    <div className='inputsColumn'>
                        <input type="text" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                    </div>
                    */}

                    <div className='inputsColumn'>
                        <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Titulo' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                            <option value="">Categorias</option>
                            {
                                categorias.map(item => (
                                    <option value={item?.idCategoria}>{item?.categoria}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroMasVendido} onChange={(e) => setFiltroMasVendido(e.target.value)}>
                            <option value="">Más vendidos</option>
                            <option value="si">Si</option>
                            <option value="no">No</option>

                        </select>
                    </div>

                    
                    {/* 
<button className='reverse' onClick={invertirOrden}>
  {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
</button>
*/}

                </div>

            </div>


            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">


                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>

                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content" style={{"width": "95%","max-width": "inherit"}}>
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagenes' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagenes')}
                                >
                                    Editar Imagenes
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Disponible</legend>
                                    <select
                                    
                                        value={productoDisponible}
                                        onChange={(e) => setProductoDisponible(e.target.value)}
                                    >
                                        <option value={producto.disponible}>{producto.disponible}</option>
                                        <option value="Si">Si</option>
                                        <option value="No">No</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Titulo</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo !== '' ? nuevoTitulo : producto.titulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecio !== '' ? nuevoPrecio : producto.precio}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Descripcion</legend>
                                    <textarea
                                        type="text"
                                        value={nuevaDescripcion}
                                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoria</legend>
                                    <select
                                        value={nuevaCategoria !== '' ? nuevaCategoria : producto.categoria}
                                        onChange={(e) => {
                                            setNuevaCategoria(e.target.value)
                                            onCheckCategoriaEsServicio(e.target.value);
                                        }}
                                    >

                                        {
                                            categorias
                                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                                .map(categoriaFiltrada => (

                                                    <option value={producto.categoria}> {categoriaFiltrada.categoria}</option>
                                                ))
                                        }

                                        {
                                            categorias.map(item => (
                                                <option value={item?.idCategoria}>{item?.categoria}</option>
                                            ))
                                        }
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Más vendido</legend>
                                    <select
                                        value={nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido}
                                        onChange={(e) => setNuevoMasVendido(e.target.value)}
                                    >
                                        <option value={producto.masVendido}>{producto.masVendido}</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                </fieldset>
                              
                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                            </div>


                            {/* Filtramos los profesionales antes de mostrar la configuración.
                              Solo se muestran los profesionales que tienen la 'nuevaCategoria' 
                              dentro de su columna 'categorias'.
                            */}
                            {categoriaEsServicio && nuevaCategoria && (
                              <div className="servicios-config-container">
                                <hr style={{ border: '0.5px solid #444', margin: '20px 0' }} />
                                <h2 style={{ color: 'var(--text-color2)', marginBottom: '20px' }}>
                                  Configuración de Agenda por Profesional
                                </h2>
                                
                                {profesionales
                                  .filter((prof) => {
                                    try {
                                      // Parseamos las categorías del profesional (que vienen como JSON string)
                                      const catsProf = typeof prof.categorias === 'string' 
                                        ? JSON.parse(prof.categorias) 
                                        : prof.categorias;
                                      
                                      // Verificamos si la categoría seleccionada en el producto (nuevaCategoria)
                                      // está presente en el array del profesional.
                                      return Array.isArray(catsProf) && catsProf.includes(nuevaCategoria.toString());
                                    } catch (e) {
                                      return false; // Si hay error en el JSON, no lo mostramos
                                    }
                                  })
                                  .map((prof) => (
                                    <div key={prof.id} className="professional-schedule-block">
                                      <h3 className="prof-title">
                                        Profesional: <strong>{prof.nombre}</strong>
                                      </h3>

                                      {/* Tiempo estimado individual */}
                                      <fieldset className="service-time-field">
                                        <legend>Duración del turno (minutos)</legend>
                                        <input
                                          type="number"
                                          min="5"
                                          step="5"
                                          value={demora[prof.id] || ''} 
                                          onChange={(e) => cambiarDemoraProfesional(prof.id, e.target.value)}
                                          placeholder="Ej: 30"
                                        />
                                      </fieldset>

                                      {/* Días y Turnos */}
                                      <fieldset className="service-turns-field">
                                        <legend>Días de atención y horarios</legend>
                                        <div className="days-grid">
                                          {WEEKDAYS.map((dia) => {
                                            const configDia = dias[prof.id] && dias[prof.id][dia];

                                            return (
                                              <div key={dia} className={`day-item-card ${configDia ? "active" : ""}`}>
                                                <label className="day-checkbox-label">
                                                  <input
                                                    type="checkbox"
                                                    checked={!!configDia}
                                                    onChange={() => toggleDia(prof.id, dia)}
                                                  />
                                                  <span>{dia === "domingo" ? "domingo y/o festivo" : dia}</span>
                                                </label>

                                                {configDia && (
                                                  <div className="day-config-content">
                                                    <div className="time-inputs-row">
                                                      <div className="time-group">
                                                        <label>Inicio</label>
                                                        <input
                                                          type="time"
                                                          value={configDia.inicio}
                                                          onChange={(e) => cambiarHora(prof.id, dia, "inicio", e.target.value)}
                                                        />
                                                      </div>
                                                      <div className="time-group">
                                                        <label>Fin</label>
                                                        <input
                                                          type="time"
                                                          value={configDia.fin}
                                                          onChange={(e) => cambiarHora(prof.id, dia, "fin", e.target.value)}
                                                        />
                                                      </div>
                                                    </div>

                                                    <div className="slots-container">
                                                      <label className="slots-label">Turnos generados (click para quitar):</label>
                                                      <div className="slots-wrapper">
                                                        {configDia.turnos.map((t, idx) => (
                                                          <button
                                                            key={idx}
                                                            type="button"
                                                            className={`slot-pill ${t.activo ? 'is-active' : 'is-disabled'}`}
                                                            onClick={() => toggleTurnoEspecifico(prof.id, dia, t.hora)}
                                                          >
                                                            {t.hora}
                                                          </button>
                                                        ))}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </fieldset>
                                    </div>
                                  ))}

                                {/* Mensaje amigable si no hay profesionales en esa categoría */}
                                {profesionales.filter(p => {
                                    try {
                                        const c = JSON.parse(p.categorias);
                                        return c.includes(nuevaCategoria.toString());
                                    } catch { return false; }
                                }).length === 0 && (
                                    <p style={{ color: 'orange', textAlign: 'center' }}>
                                        No hay profesionales asignados a esta categoría.
                                    </p>
                                )}
                              </div>
                            )}

                            <button className='btnPost' onClick={() => handleUpdateText(producto.idProducto)} >Guardar </button>

                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>
                            <div className='previevProduct'>
                                {imagenPreview ? (
                                    <img src={imagenPreview} alt="Vista previa de la imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />
                                ) : (
                                    <>
                                        {producto.imagen1 ? (
                                            <img src={producto.imagen1} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}

                                {imagenPreview2 ? (
                                    <img src={imagenPreview2} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen2 ? (
                                            <img src={producto.imagen2} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen2)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview3 ? (
                                    <img src={imagenPreview3} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen3 ? (
                                            <img src={producto.imagen3} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen3)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview4 ? (
                                    <img src={imagenPreview4} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen4 ? (
                                            <img src={producto.imagen4} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen4)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                            <fieldset>
                                <legend>Editar Imagen1 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen, setImagenPreview)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen2 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen2, setImagenPreview2)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen3 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen3, setImagenPreview3)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen4 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen4, setImagenPreview4)} />
                            </fieldset>
                            <button className='btnPost' onClick={() => handleEditarImagenBanner(producto.idProducto)}>Guardar </button>

                        </div>



                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Producto</th>
                            <th>Titulo</th>
                            <th>Precio</th>
                            <th>Categoria</th>
                            <th>Imagen</th>
                            <th>Imagen 2</th>
                            <th>Imagen 3</th>
                            <th>Imagen 4</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productosFiltrados.map(item => (
                            <tr key={item.idProducto}>
                                <td>{item.idProducto}</td>
                                <td>{item.titulo}</td>

                                <td style={{
                                    color: '#008000',
                                }}>
                                    {moneda} {`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>

                                {categorias
                                    .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === item.idCategoria)
                                    .map(categoriaFiltrada => (
                                        <td
                                            key={categoriaFiltrada.idCategoria}
                                            style={{ color: '#DAA520' }}
                                        >
                                            {categoriaFiltrada.categoria}
                                        </td>
                                    ))
                                }

                                <td>
                                    {item.imagen1 ? (
                                        <img src={item.imagen1} alt="imagen1" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.imagen2 ? (
                                        <img src={item.imagen2} alt="imagen2" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.imagen3 ? (
                                        <img src={item.imagen3} alt="imagen3" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.imagen4 ? (
                                        <img src={item.imagen4} alt="imagen4" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='duplicar' onClick={() => duplicarProducto(item.idProducto)}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <Anchor className='editar2'  to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </Anchor>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};
